import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { isTenantAdmin } from '../../models/enums/user-role.enum';
import { AuthService } from '../../services/auth.service';
import { guideBySlug } from '../../shared/help/help-content';

/** An unknown guide address shows Page not found; an owner-only guide shows No access to staff. */
export const guideGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const guide = guideBySlug(route.paramMap.get('slug'));
  if (!guide) return router.createUrlTree(['/not-found']);

  return inject(AuthService).currentProfile$.pipe(
    take(1),
    map((profile) => (guide.ownerOnly && !isTenantAdmin(profile?.role) ? router.createUrlTree(['/forbidden']) : true)),
  );
};
